import { LayoutModule } from '@angular/cdk/layout';
import { MatCardModule } from '@angular/material/card';
import { SharedModule } from './modules/_shared/shared.module';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, APP_INITIALIZER } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Route } from '@angular/router';

import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';

import { ContactGqlService } from './data-services/dynamics/contact-gql.service'
import { OptionSetsGqlService } from './data-services/dynamics/optionsets-gql.service'
import { CslbLicenseService } from './data-services/services/license/cslb-license.service';
import { AuthorizationGqlService } from './data-services/dynamics/authorization-gql.service';
import { ApiService, AppLoadService, DialogSolutionDeployingComponent } from '@ebb-v2/ebb-integration';
import { OptionSetsApiService, AuthorizationService } from './data-services';

import { ContractorAppComponent } from './app.component';

import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { DeviceDetectorService } from 'ngx-device-detector';
import { RECAPTCHA_SETTINGS, RecaptchaFormsModule, RecaptchaModule, RecaptchaSettings } from 'ng-recaptcha-2';
import { APOLLO_PROVIDERS } from './apollo.config';
export function get_environ_settings(appLoadService: AppLoadService) {
  return () => appLoadService.getEnvironSettings();
}

export const appRoutes: Route[] = [
  {
    path: '',
    redirectTo: 'register',
    pathMatch: 'full'
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./modules/profile/profile.module').then(m => m.ProfileModule)
  },
  {
    path: 'application',
    loadChildren: () => import('./modules/application/application.module').then(m => m.ApplicationModule)
  },
  {
    path: 'register',
    loadChildren: () => import('./modules/registration/registration.module').then(m => m.RegistrationModule)
  }
];

@NgModule({ declarations: [
       ContractorAppComponent,
        DialogSolutionDeployingComponent
    ],
    
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
    ], imports: [SharedModule, 
        CommonModule,
        BrowserModule,
        LayoutModule,
        FormsModule,
        MatCardModule,
        BrowserAnimationsModule,
        NgxMaskDirective, NgxMaskPipe,
        HttpClientModule,
        RecaptchaModule,
        RecaptchaFormsModule,
        RouterModule.forRoot(appRoutes, { enableTracing: true, scrollPositionRestoration: 'enabled' })], providers: [
        CslbLicenseService, provideNgxMask(),
        ContactGqlService,
        ApiService,
        AppLoadService, DeviceDetectorService,
        { provide: APP_INITIALIZER, useFactory: get_environ_settings, deps: [AppLoadService], multi: true },
        {
            provide: RECAPTCHA_SETTINGS,
            useFactory: (appLoadService: AppLoadService): RecaptchaSettings => ({
                siteKey: appLoadService.getRecaptchaKey()
            }),
            deps: [AppLoadService]
        },
        { provide: OptionSetsApiService, useClass: OptionSetsGqlService },
        { provide: AuthorizationService, useClass: AuthorizationGqlService },
        ...APOLLO_PROVIDERS, 
    ] , bootstrap: [ContractorAppComponent],})
export class ContractorAppModule {}
